export default "__VITE_ASSET__CxnCONxS__"